import { errors2String } from './../../helpers/utils';
import axios from 'axios';
import _ from 'lodash';
import types from './authTypes';

import { toastr } from "react-redux-toastr";

import { setLoading } from './../../helpers/redux/loading';
import { BASE_AUTH, BASE_OAPI } from './../../config/consts';

/**
 * @function validateToken - Função que serve para verificar se o
 * token de acesso do usuário está ativo
 * @param {String} token - Token do usuário que está salvo
 * @returns {Object} Evento que diz para a aplicação se o token está válido
 */
export const validateToken = (token) => {
	return dispatch => {
		delete axios.defaults.headers.common['authorization'];
		axios.post(`${BASE_AUTH}/validate-token`, {token})
			.then((response) => {
                dispatch({
                    type: types.TOKEN_VALIDATED,
                    payload: response.data.content.valid
                });
                dispatch({
                    type: 'APPLICATION_LOADER',
                    payload: false
                })
			})
			.catch((e) => {
                dispatch({
                    type: types.TOKEN_VALIDATED,
                    payload: false
                });
                dispatch({
                    type: 'APPLICATION_LOADER',
                    payload: false
                })
			})
	}
}
/**
 * @function login - Função utilizada para solicitar os dados de
 * acesso e do usuário
 * @param {Object} values 
 * @param {String} router 
 * @returns {Function} Função para pegar os dados do usuário
 */
export const login = (values, router) => {
    return (dispatch) => {
        axios.post(`${BASE_AUTH}/login`, values)
            .then((response) => {
                const data_token = {
                    token: response.data.content.token,
                    token_type: response.data.content.token_type,
                }
                const user = {...response.data.content};
                delete user['token'];
                delete user['token_type'];
                dispatch([
                    { type: types.TOKEN_FETCHED, payload: data_token },
                    { type: types.TOKEN_VALIDATED, payload: true },
                    setUserData(user)
                ]);
            })
            .catch((err) => {
                try {
                    dispatch({ type: 'ERROR_LOGIN'});
                    toastr.error('Erro!', err.response.data.content.message);
                    dispatch(setLoading(types.AUTH_LOADING, false));
                } catch (error) {
                    toastr.error('Erro!', 'Aconteceu um erro inesperado por favor tente mais tarde!');
                }
                dispatch({ type: 'ERROR_LOGIN'});
                dispatch(setLoading(types.AUTH_LOADING, false));                
            });
    }
}

/**
 * @function register - Função utilizada para solicitar os dados de
 * acesso e do usuário
 * @param {Object} values 
 * @param {String} router 
 * @returns {Function} Função para pegar os dados do usuário
 */
export const register = (values, router = undefined) => {
    return (dispatch) => {
        const userActive = {
            ...values,
            active: true
        }
        axios.post(`${BASE_AUTH}/signup`, userActive, router)
            .then((response) => {
                dispatch(setLoading(types.AUTH_LOADING, false));
                toastr.success('Sucesso!', response.data.content[0]);
                setTimeout(() => {
                    if (!_.isUndefined(router)) {
                        router.replace("/");
                    }
                    // toastr.info(
                    //     'Autorização para acesso',
                    //     'Favor solicitar ao seu superior as permissões necessárias para acessar o sistema',
                    //     { timeOut: 0, progressBar: false }
                    // );    
                }, 500);
            })
            .catch((err) => {
                
                dispatch({ type: 'ERROR_LOGIN'});
                toastr.error('Erro!', err.response.data.content.message);
                dispatch(setLoading(types.AUTH_LOADING, false));
            });
    }
}

/**
 * @function logout - Função que retira os dados do usuário do
 * cache do navegador e revoga o token na API
 * @returns {Object} - Ação para colocar o reducer no estado
 * inicial
 */
export const logout = () => {
    return (dispatch) => {
        dispatch(resetApplication());
        dispatch({ type: types.LOGOUT });
    }
}

/**
 * @function setUserData - Função que serve para colocar os dados
 * do usuário no reducer
 * @param {String} user 
 * @returns {Object} Evento que diz para a aplicação inserir o usuário
 * no reducer
 */
const setUserData = (user) => {
    return {
        type: types.USER_FETCHED,
        payload: user
    }
}

/**
 * @function forgotPassword - Função utilizada para que o usuário
 * consiga recuparar sua senha
 * @param {string} email 
 * @param {String} router 
 * @returns {Function} Função para enviar email de recuperação de senha
 */
export const forgotPassword = (email, router = undefined) => {
    return (dispatch) => {
        axios.post(`${BASE_OAPI}/forgot-password`, email)
            .then((response) => {
                dispatch(setLoading(types.AUTH_LOADING, false));
                toastr.success('Sucesso!', response.data.content.message);
                setTimeout(() => {
                    if (!_.isUndefined(router)) {
                        router.replace("/");
                    }
                }, 1500);
            })
            .catch((err) => {
                console.log(err)
                const errors = err.response.data.content.message;
                toastr.error('Erro!', errors);
                dispatch(setLoading(types.AUTH_LOADING, false));

                try {
                    const errors = errors2String(err.response.data.content.errors);
                    dispatch({ type: 'ERROR_FORGOT_PASSWORD'});
                    toastr.error('Erro!', errors);
                } catch (error) {
                    dispatch({ type: 'ERROR_FORGOT_PASSWORD'});
                    toastr.error('Erro!', 'Não foi possível enviar o email, por favor tente novamente mais tarde!');
                    console.log(error);
                }
            });
    }
}

/**
 * @function verifyTokenRecoveryPassword - Função utilizada para que possamos
 * testar se o token da recuperação de senha está válido
 * @param {string} token 
 * @returns {Function} Função para permitir o usuário trocar a senha
 */
export const verifyTokenRecoveryPassword = (token, router = undefined) => {
    return (dispatch) => {
        axios.post(`${BASE_OAPI}/recovery-pass/is-valid`, {token})
            .then((response) => {
                dispatch({
                    type: types.RESTORE_PASSWORD_VALIDATED, payload: response.data
                })
                dispatch(setLoading(types.AUTH_LOADING, false));
                if(response.data.content.used) {
                    if (!_.isUndefined(router)) {
                        router.replace("/");
                    }
                    setTimeout(() => {
                        toastr.info('Token já utilizado!', 'O token informado já foi utilizado, por favor tente fazer a recuperação de senha novamente.');
                    }, 1500);
                }
            })
            .catch((err) => {
                dispatch({
                    type: types.RESTORE_PASSWORD_VALIDATED, payload: err.response.data
                })
            });
    }
}

/**
 * @function restorePassword - Função utilizada para que o usuário
 * consiga recuparar sua senha
 * @param {Object} values 
 * @param {String} router 
 * @returns {Function} Função para mudar a senha do usuário
 */
export const restorePassword = (values, router = undefined) => {
    return (dispatch) => {
        axios.post(`${BASE_OAPI}/recovery-pass`, values)
            .then((response) => {
                dispatch(setLoading(types.AUTH_LOADING, false));
                toastr.success('Sucesso!', 'Senha atualizada com sucesso!');
                setTimeout(() => {
                    if (!_.isUndefined(router)) {
                        router.replace("/");
                    }
                }, 1500);
            })
            .catch((err) => {
                console.log(err)
                const errors = err.response.data.content.message;
                toastr.error('Erro!', errors);
                dispatch(setLoading(types.AUTH_LOADING, false));
            });
    }
}

export const resetApplication = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_APPLICATION" });
    }
}